import styled from "styled-components";

export const Styled = styled.div`
   width: 380px;

   .select {
      h4 { width: 70px; }
      &:not(:first-of-type) {
         margin-top: 10px;
      }
   }
   .textInput {
      h4 { width: 100px; }
      &:not(:first-of-type) {
         margin-top: 10px;
      }
   }
   .textarea {
      margin-top: 10px;
      > div {
         height: 90px;
         min-height: 90px;
         max-height: 140px;
      }
   }
   .linkBtn {
      display: block;
      margin: 6px 0 4px;
      background: none;
      border: none;
      color: #2563eb;
      font-size: 12.5px;
      font-weight: 600;
      cursor: pointer;
      padding: 0;

      &:hover { text-decoration: underline; }
   }
   .newTable {
      padding: 10px;
      margin-bottom: 10px;
      border: 1px solid rgb(220, 220, 220);
      border-radius: 6px;
      background: rgb(250, 250, 250);

      .textInput:not(:first-of-type) { margin-top: 8px; }
   }
   .newTableActions {
      display: flex;
      gap: 8px;
      margin-top: 10px;

      .btn1 { flex: 1; justify-content: center; }
   }
`;
